import React from "react";
import { InputLabelProps } from "./Input.types";
import { Label } from "@fourkites/elemental-atoms";

const InputLabel = ({
  label,
  hideLabel,
  required,
  inputId,
}: InputLabelProps): React.ReactElement<InputLabelProps> => {
  return typeof label === "string" ? (
    <Label
      htmlFor={inputId}
      size="large"
      required={required}
      hidden={hideLabel}
    >
      {label}
    </Label>
  ) : (
    React.cloneElement(label, {
      htmlFor: inputId,
      size: "large",
      hidden: hideLabel,
      required,
    })
  );
};

export default InputLabel;
